<template>
  <div id="requirements" class="networkshops-requirements">
    <h2 class="vz-text-align-left">{{ requirementsTitle }}</h2>
    <div class="networkshops-requirements-links" :class="{ 'networkshops': isNetworkshops }">
      <vz-button
        large
        :outline="isNetworkshops"
        variant="primary" 
        to="/marketplaces"
      >
        Маркетплейсы
      </vz-button>
      <vz-button
        large
        :outline="!isNetworkshops"
        variant="primary" 
        to="/networkshops"
      >
        Торговые сети
      </vz-button>
    </div>
    <div class="networkshops-requirements-images">
      <nuxt-link v-for="{image, alt, route} in requirementsImages" :to="route">
        <NuxtImg :src="image" :alt="alt" format="webp" loading="lazy" />
      </nuxt-link>
    </div>
    <b>{{ requirementsListTitle }}</b>
    <div class="networkshops-requirements-items">
      <div v-for="{ icon, text } of requirementsList">
        <vz-icon
          :url="icon"
          no-masked-icon
          variant="primary"
          size="36"
        />
        <p>{{ text }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {getPageContent} from '~/api/content';
import {storeToRefs} from 'pinia';
import $breakpoints from '~/composables/breakpoints';

const props = defineProps({
  requirementsType: {
    type: String,
    default: 'marketplaces'
  }
})

const data = (await getPageContent('/networkshops')).blocks?.requirements

const requirementsTypes = computed(() => [
  {
    title: data.marketplacesTitle,
    value: 'marketplaces'
  },
  {
    title: data.networkshopsTitle,
    value: 'networkshops'
  }
])

const isNetworkshops = computed(() => {
  return props.requirementsType === 'networkshops'
}) 

const requirementsTitle = computed(() => {
  return `Мы доставляем ${ isNetworkshops.value ? 'товар на склады сетевых магазинов' : 'на склады маркетплейсов и сетей:' }`
})

const requirementsListTitle = computed(() => {
  return data[`${props.requirementsType}ListTitle`]
})

const requirementsList = computed(() => {
  const list =  data[`${props.requirementsType}List`].split(';')
  return [
    {
      icon: '/svg/box-transportation.svg',
      text: list[0]
    },
    {
      icon: '/svg/vz-time-success.svg',
      text: list[1]
    },
    {
      icon: '/svg/vz-success.svg',
      text: list[2]
    },
    {
      icon: isNetworkshops.value ? '/svg/vz-signature.svg' : '/svg/vz-roll.svg',
      text: list[3]
    },
  ]
})

const requirementsImages = computed(() => {
  const images = isNetworkshops.value
    ? ['leroy-merlin.png', 'x5group.png', 'castorama.png', 'lenta.png', 'magnit.png',
        'okey.png', 'maxidom.png', 'mvideo.png', 'ashan.png'].map(image => ({image}))
    : [
        {
          image: 'wildberries.png',
          route: {path: '/wildberries'}
        },
        {
          image: 'yandex.png',
          route: {path: '/yandex-market'}
        },
        {
          image: 'ozon.png',
          route: {path: '/ozon'}
        }
      ]

  const alts = isNetworkshops.value 
  ? ['Леруа Мерлен, Leroy Merlin', 'Пятерочка, Х5', 'Касторама, Castorama', 'Лента', 'Магнит',
      'Okey, Окей', 'Максидом, Maxidom', 'М Видео, M video', 'Ашан']
  : ['Wildberries, Вайлдберриз', 'Yandex, Яндекс', 'Ozon, Озон']

  return images.map((img,i) => ({
    ...img,
    alt: alts[i],
    image: `/images/pages/networkshops/companies/${img.image}`
  }))
})
</script>

<style scoped lang="scss">
.networkshops-requirements {
  padding: 40px;
  background-color: $box-gray;
  margin-bottom: 110px;
  border-radius: 4px;

  &-links {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media screen and (max-width: $pub-sm) {
      grid-template-columns: 1fr;
    }

    &.networkshops {
      .vz-button:last-child {
        order: 0;
      }

      .vz-button:first-child {
        order: 1;
      }
    }

    .vz-button {
      width: 100%;
      justify-content: center;
    }
  }

  &-items {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    > div {
      display: flex;
      align-items: flex-start;
      gap: 25px;
    }
  }

  &-images {
    margin: 60px -10px 20px;
    display: grid;
    justify-content: space-between;
    justify-items: center;
    grid-template-columns: repeat(3, 1fr);

    img {
      width: 100%;
      max-width: 350px;
    }
  }

  b {
    display: block;
    margin-top: 60px;
    margin-bottom: 30px;
  }

  @media screen and (max-width: $pub-md) {
    margin-bottom: 90px;

    &-items {
      > div {
        flex-direction: column;
      }
    }
  }
  @media screen and (max-width: $pub-sm) {
    margin-bottom: 70px;
    &-images {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media screen and (max-width: $pub-xs) {
    padding: 30px 20px;
    &-items {
      grid-template-columns: 1fr;
      > div {
        flex-direction: row;
      }
    }
    &-images {
      margin-top: 40px;
      grid-template-columns: 1fr;
    }
    b {
      margin-top: 40px;
      margin-bottom: 20px;
    }
  }
}
</style>
